"use strict";

globalThis.Hologram.pendingScripts ??= [];

globalThis.Hologram.pendingScripts.push({
  digest: new URL(document.currentScript.src).pathname.match(/-([^-]+)\.js$/)[1],
  define: (deps) => {
    const {
      Bitstring,
      ERTS,
      HologramBoxedError,
      HologramInterpreterError,
      Interpreter,
      MemoryStorage,
      Type,
      Utils,
    } = deps;

Interpreter.defineErlangFunction("erlang", "*", 2, (left, right) => {
    if (!Type.isNumber(left) || !Type.isNumber(right)) {
      Interpreter.raiseBifError("badarith", "erlang", "*", [left, right]);
    }

    const [type, leftValue, rightValue] = Type.maybeNormalizeNumberTerms(
      left,
      right,
    );

    const result = leftValue.value * rightValue.value;

    return type === "float" ? Type.float(result) : Type.integer(result);
  });

Interpreter.defineErlangFunction("erlang", "abs", 1, (number) => {
    if (Type.isFloat(number)) {
      return Type.float(Math.abs(number.value));
    } else if (Type.isInteger(number)) {
      const value = number.value;
      return Type.integer(value < 0n ? -value : value);
    }

    Interpreter.raiseBifError("badarg", "erlang", "abs", [number]);
  });

Interpreter.defineErlangFunction("erlang", "band", 2, (integer1, integer2) => {
    if (!Type.isInteger(integer1) || !Type.isInteger(integer2)) {
      Interpreter.raiseBifError("badarith", "erlang", "band", [
        integer1,
        integer2,
      ]);
    }

    return Type.integer(integer1.value & integer2.value);
  });

Interpreter.defineErlangFunction("erlang", "div", 2, (integer1, integer2) => {
    if (
      !Type.isInteger(integer1) ||
      !Type.isInteger(integer2) ||
      integer2.value === 0n
    ) {
      Interpreter.raiseBifError("badarith", "erlang", "div", [
        integer1,
        integer2,
      ]);
    }

    // TODO: support integers outside Number range
    return Type.integer(
      Math.trunc(Number(integer1.value) / Number(integer2.value)),
    );
  });
  },
});

document.dispatchEvent(new CustomEvent("hologram:scriptLoaded"));